// extracted by mini-css-extract-plugin
module.exports = {"icon":"SelectDateMode_icon__QLDB1","description":"SelectDateMode_description__QnyrE"};